import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

import createLogger from "vuex/dist/logger";
import storage from "@/tools/storage.js";
import defineConfig from "@/config/defineConfig.js";

import permission from "./modules/permission";

Vue.use(Vuex);

var debug = process.env.NODE_ENV !== "production";

var state = {
  isLoading: false,

  loadingText: "正在处理，请稍候...",

  fieldchange: {},

  bizRouteIndex: parseInt(storage.$storage.getSession(defineConfig.$definecfg.BIZ_ROUTE_INDEX)) || 0,

  bizRouteTable: storage.$storage.getJsonSession(defineConfig.$definecfg.BIZ_ROUTE_TABLE) || null,

  busicode: storage.$storage.getSession(defineConfig.$definecfg.BUSI_CODE) || null,

  usertype: storage.$storage.getSession(defineConfig.$definecfg.USER_TYPE) || 0,

  navRouteTable: null,

  componentbuttonclick: "",

  modulebuttonclick: "",

  moduleCustomizeButtonClick: "",

  moduleZDCustomizeButtonClick: "",

  moduleBenifiCustomizeButtonClick: "",
  moduleImportButtonClick: "",
  moduleDownloadButtonClick: "",

  isLogin: false,

  hasPassword: false,

  oldBizData: storage.$storage.getJsonSession(defineConfig.$definecfg.OLD_BIZ_DATA) || null,

  leftClickState: "",

  isExteral: false,

  preBizRouteIndex: null,

  transBizData: null,
  token: storage.$storage.getSession(defineConfig.$definecfg.TOKEN),
  apptSn: storage.$storage.getSession(defineConfig.$definecfg.APPT_SN),
  bSno: storage.$storage.getSession(defineConfig.$definecfg.B_SNO),
  openAcctType: storage.$storage.getSession(defineConfig.$definecfg.OPEN_ACCTTYPE),
  apptStatus: storage.$storage.getSession(defineConfig.$definecfg.APPT_STATUS),
  userInfo: storage.$storage.getJsonSession(defineConfig.$definecfg.USER_INFO) || null,
  customerInfo: storage.$storage.getJsonSession(defineConfig.$definecfg.CUSTOMER_INFO) || null,
  canCleanData: storage.$storage.getJsonSession(defineConfig.$definecfg.CAN_CLEAN_DATA) || true,
  mobileLogin: storage.$storage.getJsonSession(defineConfig.$definecfg.MOBILE_LOGIN) || false,
  lastMobileLogin: storage.$storage.getJsonSession(defineConfig.$definecfg.LAST_MOBILE_LOGIN) || false,
  pageReload: false
};

export default new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {
    permission: permission
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});


//////////////////
// WEBPACK FOOTER
// ./src/vuex/index.js
// module id = 122
// module chunks = 2